import Management from "./management/school_management.store";

export default {
  modules: { Management },
};
